import React from 'react';
import { useEffect, useState } from 'react';
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';


const ProducteursArticles = ({ uNum }) => {
    const [articles, setArticles] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    useEffect(() => {
        // Fetch articles based on uNum
        fetch(`${URL_COURTJUS_BACK}/articles/${uNum}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(data => {
                setArticles(data);
            });
    }, [uNum]); // Dépendance sur uNum pour refetch les articles lorsque uNum change

    return (
        <p>
            {articles
                .filter(article => article.aStockIni > 0) // Filtrer les articles dont aStockIni est > 0
                .sort((a, b) => a.aLibelle.localeCompare(b.aLibelle)) // Trier les articles par aLibelle
                .map((article, index) => (
                    <span className='biasse-list-particip' key={index}>{article.aLibelle}</span>
                ))}
        </p>
    );
};

export default ProducteursArticles;